import * as React from 'react';
import { faListNumeric } from '@fortawesome/pro-regular-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { useLocalization } from '~/framework';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const OrderedListButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleOrderedList().run()}
         isActive={editor.isActive('orderedList')}
         isDisabled={!editor.can().toggleOrderedList()}
         icon={<FontAwesomeIcon icon={faListNumeric} />}
         title={_js('Add a numbered list')}
         shortcut={'shift+7'}
      />
   );
};
